import { createApp, markRaw } from 'vue'
import App from './App.vue'
import router from './router'

import { IonicVue } from '@ionic/vue'

import axios from 'axios'
import { PiniaPluginContext, createPinia } from 'pinia'

import { Drivers, Storage } from '@ionic/storage'

// @ts-ignore
import VueVirtualScroller from 'vue-virtual-scroller'

import Vue3TouchEvents from 'vue3-touch-events'

import '@/assets/styles/main.css'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css'
import '@ionic/vue/css/float-elements.css'
import '@ionic/vue/css/text-alignment.css'
import '@ionic/vue/css/text-transformation.css'
import '@ionic/vue/css/flex-utils.css'
import '@ionic/vue/css/display.css'

/* Theme variables */
import './theme/variables.css'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import { Capacitor } from '@capacitor/core'
import { Keyboard, KeyboardResize } from '@capacitor/keyboard'
import { useSettingsStore } from './stores/settingsStore'

const api = import.meta.env.VITE_API_URL
axios.defaults.baseURL = api

function localStoragePiniaPlugin() {
  const ionicStorage = new Storage({
    driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
  })
  const setupStorage = async () => {
    await ionicStorage.create()
  }
  setupStorage()
  return { ionicStorage: markRaw(ionicStorage), stateLoaded: false }
}

function localAuthPiniaPlugin({ store }: PiniaPluginContext) {
  store.ionicStorage.get('token').then((token: string) => {
    store.token = token ? token : null
  })

  // TODO: Remove this in favor of the explicit loading in the login page?
  store.ionicStorage.get('refreshToken').then((refreshToken: string) => {
    store.refreshToken = refreshToken ? refreshToken : null
    // console.log('localAuthPiniaPlugin - Loaded refresh', store.refreshToken)
  })

  store.ionicStorage
    .get('user')
    .then((user: string) => {
      store.user = user ? user : null
    })
    .finally(() => {
      store.stateLoaded = true
    })
}

function routerPiniaPlugin({ store }: PiniaPluginContext) {
  store.router = markRaw(router)
}

const pinia = createPinia()

const app = createApp(App)

if (Capacitor.isNativePlatform()) {
  Keyboard.setResizeMode({ mode: KeyboardResize.Body })
}

app
  .use(IonicVue, {
    animated: true,
    swipeBackEnabled: true,
    mode: 'ios',
  })
  .use(pinia)
  .use(router)
  .use(VueVirtualScroller)
  .use(Vue3TouchEvents)

pinia.use(localStoragePiniaPlugin)
pinia.use(localAuthPiniaPlugin)
pinia.use(routerPiniaPlugin)
pinia.use(() => {
  return { axios: markRaw(axios) }
})

app.provide('api', api)
app.provide('axios', axios)

useSettingsStore()
  .initDarkMode()
  .then(() => {
    router.isReady().then(() => {
      app.mount('#app')
    })
  })
